import React from 'react';

import { ModifyPlaylistButton } from '@atlassian/ai-audio/ui/buttons';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';

const WrappedButton = ({ flags, contentId, contentType, contentTitle }) => {
	const { cloudId } = useSessionData();

	return (
		cloudId &&
		(contentType === 'page' || contentType === 'blogpost') && (
			<ModifyPlaylistButton
				cloudId={cloudId}
				contentId={contentId}
				contentType={contentType}
				title={contentTitle}
				subtle
				flagsOverride={flags}
			/>
		)
	);
};

export const FeedAudioPlaylistButton = withFlags(WrappedButton);
